import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { Spinner } from "../../../components/ui/spinner";

type DeleteProps = {
  blueprint: any | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};
const DeleteBlueprint = ({
  blueprint,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteProps) => {
  const { t } = useTranslation();
  const open = blueprint !== null;

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !isDeleting) onCancel();
      }}
    >
      <AlertDialogContent className="border-border bg-card">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground">
            Delete Blueprint
          </AlertDialogTitle>
          <AlertDialogDescription>
            {blueprint
              ? `Are you sure you want to delete ${blueprint.name}?`
              : ""}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="border-border bg-card text-foreground hover:bg-accent"
            disabled={isDeleting}
          >
            {t("common.discard")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            aria-busy={isDeleting}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {isDeleting ? (
              <>
                <Spinner className="size-4" />
                <span>{t("common.deleting")}</span>
              </>
            ) : (
              t("common.delete")
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteBlueprint;
